import { computed } from 'vue'
import User from '../store/Models/User'

// Unable to extract types
type UserFields = Record<keyof ReturnType<typeof User['fields']>, any>

export const useUser = () => {
  return computed(() => User.query().first() as unknown as UserFields)
}